import { render, staticRenderFns } from "./SLigoAssistant.vue?vue&type=template&id=906cfd66&"
import script from "./SLigoAssistant.vue?vue&type=script&lang=ts&"
export * from "./SLigoAssistant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports